import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { firestore } from "../../helpers/Firebase";
import { SetActiveItem } from "../../redux/activeItem/actions";
import MainPage from "./MainPage";
import Helper from "./helper";
const ActiveHelper = ({ title,
    showCreateButton = false,
    selected,
    elements,
    data,
    tableColumns,
    permenatDelete = false,
    filterComponent = null,
    exportCSV = null,
    enableSorting = false,
    defaultSorting = "created",
    renderAsModal = false,
    modalSize = "lg",
    modalBackdrop = "static",
    wrapClassName = "",
    sortDirection = "desc",
    customDeleteFunction = null,
    customDeleteTitle = null,
    customCreateFunction = null,
    customSubmitFunction = null,
    hideDefaultDeleteButton = false,
    confirmCustomDelete = false,
    customEditTitle = null,
    customEditFunction = null,
    customRowClickFunction = null,
    customSwitchFunction = null,
    customActionButtons = []
}) => {
    console.log('selected', selected);
    const dispatch = useDispatch();
    const { activeItem } = useSelector(state => state.activeItem)
    const authUser = useSelector(state => state.authUser)

    const selectHelper = async (helperData) => {
        let post = { general: helperData };

        // Fetch subscriptions for service providers
        if (selected === 'service_provider' && helperData?.key && !helperData?.addNew) {
            try {
                let snap = await firestore().collection('service_provider').doc(helperData.key).collection('subscriptions').get()
                if (!snap.empty) {
                    let subscriptions = snap?.docs?.reduce((val, currentVal) => {
                        val[currentVal.id] = { ...currentVal.data() }
                        return val
                    }, {})
                    post.subscriptions = subscriptions;
                }
            } catch (error) {
                console.error('Error fetching subscriptions:', error);
            }
        }

        dispatch(SetActiveItem(post))
    }

    return (
        <div>
            {
                activeItem ?
                    <Helper
                        renderAsModal={renderAsModal}
                        modalSize={modalSize}
                        modalBackdrop={modalBackdrop}
                        wrapClassName={wrapClassName}
                        title={title}
                        selected={selected}
                        elements={elements}
                        dismiss={() => {
                            dispatch(SetActiveItem(false))
                        }}
                        customSubmitFunction={customSubmitFunction}
                    /> : <></>
            }
            {renderAsModal || !activeItem ? <MainPage
                title={title}
                selected={selected}
                data={data || []}
                setSelectedItem={(e) => selectHelper(e)}
                tableColumns={tableColumns}
                permenatDelete={permenatDelete}
                filterComponent={filterComponent}
                exportCSV={exportCSV}
                user={authUser?.user}
                enableSorting={enableSorting}
                defaultSorting={defaultSorting}
                sortDirection={sortDirection}
                customDeleteFunction={customDeleteFunction}
                customDeleteTitle={customDeleteTitle}
                hideDefaultDeleteButton={hideDefaultDeleteButton}
                confirmCustomDelete={confirmCustomDelete}
                customEditTitle={customEditTitle}
                customEditFunction={customEditFunction}
                customRowClickFunction={customRowClickFunction}
                customCreateFunction={customCreateFunction}
                customSwitchFunction={customSwitchFunction}
                showCreateButton={showCreateButton}
                customActionButtons={customActionButtons}
                /> : <></>}
        </div>
    );
};

export default ActiveHelper;